export const areKeysPresent = (array, keys) => {
  return keys.every(key => array.some(obj => key in obj));
};
